import React, { useState } from 'react';
import { FaGavel, FaDownload, FaFileAlt, FaCalendar, FaEye, FaTimes } from 'react-icons/fa';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';
import { COVER_BG_IMAGE } from '../constants/cover';

const DisciplinePage = () => {
  const { language } = useLanguage();
  const [previewDoc, setPreviewDoc] = useState(null);

  const documents = [
    {
      id: 1,
      title: { 
        ar: 'قرار الدور الأول - كأس تونس', 
        fr: 'PV 1er Tour CT' 
      },
      file: 'PV 1er Tour CT.pdf',
      date: '2024-11-15',
      round: { ar: 'كأس تونس', fr: 'Coupe de Tunisie' }
    },
    {
      id: 2,
      title: { 
        ar: 'محضر رقم 01', 
        fr: 'PV N° 01' 
      },
      file: 'PV N° 01.pdf',
      date: '2024-10-20',
      round: { ar: 'الجولة 1', fr: 'Journée 1' }
    },
    {
      id: 3,
      title: { 
        ar: 'محضر رقم 02', 
        fr: 'PV N° 02' 
      },
      file: 'PV N° 02.pdf',
      date: '2024-10-27',
      round: { ar: 'الجولة 2', fr: 'Journée 2' }
    },
    {
      id: 4,
      title: { 
        ar: 'محضر رقم 03', 
        fr: 'PV N° 03' 
      },
      file: 'PV N° 03.pdf',
      date: '2024-11-03',
      round: { ar: 'الجولة 3', fr: 'Journée 3' }
    },
    {
      id: 5,
      title: { 
        ar: 'محضر رقم 04', 
        fr: 'PV N° 04' 
      },
      file: 'PV N° 04.pdf',
      date: '2024-11-10',
      round: { ar: 'الجولة 4', fr: 'Journée 4' }
    },
    {
      id: 6,
      title: { 
        ar: 'محضر رقم 05', 
        fr: 'PV N° 05' 
      },
      file: 'PV N° 05.pdf',
      date: '2024-11-17',
      round: { ar: 'الجولة 5', fr: 'Journée 5' }
    },
    {
      id: 7,
      title: { 
        ar: 'محضر رقم 06', 
        fr: 'PV N° 06' 
      },
      file: 'PV N° 06.pdf',
      date: '2024-11-24',
      round: { ar: 'الجولة 6', fr: 'Journée 6' }
    },
    {
      id: 8,
      title: { 
        ar: 'محضر رقم 07', 
        fr: 'PV N° 07' 
      },
      file: 'PV N° 07.pdf',
      date: '2024-12-01',
      round: { ar: 'الجولة 7', fr: 'Journée 7' }
    },
    {
      id: 9,
      title: { 
        ar: 'محضر رقم 08', 
        fr: 'PV N° 08' 
      },
      file: 'PV N° 08.pdf',
      date: '2024-12-08',
      round: { ar: 'الجولة 8', fr: 'Journée 8' }
    },
    {
      id: 10,
      title: { 
        ar: 'محضر رقم 09', 
        fr: 'PV N° 09' 
      },
      file: 'PV N° 09.pdf',
      date: '2024-12-15',
      round: { ar: 'الجولة 9', fr: 'Journée 9' }
    },
    {
      id: 11,
      title: { 
        ar: 'محضر رقم 10', 
        fr: 'PV N° 10' 
      },
      file: 'PV N 10.pdf',
      date: '2024-12-22',
      round: { ar: 'الجولة 10', fr: 'Journée 10' }
    },
    {
      id: 12,
      title: { 
        ar: 'محضر رقم 11', 
        fr: 'PV N° 11' 
      },
      file: 'PV N 11.pdf',
      date: '2024-12-29',
      round: { ar: 'الجولة 11', fr: 'Journée 11' }
    },
    {
      id: 13,
      title: { 
        ar: 'محضر رقم 12', 
        fr: 'PV N° 12' 
      },
      file: 'PV N 12.pdf',
      date: '2025-01-05',
      round: { ar: 'الجولة 12', fr: 'Journée 12' }
    },
    {
      id: 14,
      title: { 
        ar: 'محضر رقم 13', 
        fr: 'PV N° 13' 
      },
      file: 'PV N 13.pdf',
      date: '2025-01-12',
      round: { ar: 'الجولة 13', fr: 'Journée 13' }
    },
    {
      id: 15,
      title: { 
        ar: 'محضر رقم 14', 
        fr: 'PV N° 14' 
      },
      file: 'PV N 14.pdf',
      date: '2025-01-19',
      round: { ar: 'الجولة 14', fr: 'Journée 14' }
    }
  ];

  const text = {
    ar: {
      title: 'قرارات لجنة التأديب',
      subtitle: 'قرارات لجنة التأديب والروح الرياضية',
      download: 'تحميل PDF',
      preview: 'معاينة',
      close: 'إغلاق',
      date: 'التاريخ',
      round: 'الجولة',
      totalDocs: 'وثيقة'
    },
    fr: {
      title: 'Décisions Disciplinaires',
      subtitle: 'Décisions du Comité de Discipline et d\'Esprit Sportif',
      download: 'Télécharger PDF',
      preview: 'Aperçu',
      close: 'Fermer',
      date: 'Date',
      round: 'Journée',
      totalDocs: 'Documents'
    }
  };

  const t = text[language];

  return (
    <div style={styles.container}>
      {/* Header */}
      <section style={styles.header}>
        <h1 style={styles.title}>{t.title}</h1>
        <p style={styles.subtitle}>{t.subtitle}</p>
        <div style={styles.statsBar}>
          <div style={styles.stat}>
            <span style={styles.statNumber}>{documents.length}</span>
            <span style={styles.statLabel}>{t.totalDocs}</span>
          </div>
        </div>
      </section>

      {/* Documents Grid */}
      <section style={styles.documentsSection}>
        <div style={styles.documentsGrid}>
          {documents.map((doc, index) => (
            <div 
              key={doc.id}
              style={{
                ...styles.docCard,
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div style={styles.docIcon}>
                <FaFileAlt style={{fontSize: '50px', color: '#c41e3a'}} />
              </div>
              
              <div style={styles.docContent}>
                <h3 style={styles.docTitle}>{doc.title[language]}</h3>
                
                <div style={styles.docMeta}>
                  <div style={styles.metaItem}>
                    <FaGavel style={styles.metaIcon} />
                    <span>{doc.round[language]}</span>
                  </div>
                  <div style={styles.metaItem}>
                    <FaCalendar style={styles.metaIcon} />
                    <span>
                      {new Date(doc.date).toLocaleDateString(
                        language === 'ar' ? 'ar-TN' : 'fr-FR',
                        { day: 'numeric', month: 'long', year: 'numeric' }
                      )}
                    </span>
                  </div>
                </div>

                <div style={styles.docActions}>
                  <button
                    onClick={() => setPreviewDoc(doc)}
                    style={styles.previewBtn}
                  >
                    <FaEye style={styles.btnIcon} />
                    {t.preview}
                  </button>
                  <a 
                    href={`/documents/discipline/${doc.file}`}
                    download
                    style={styles.downloadBtn}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaDownload style={styles.btnIcon} />
                    {t.download}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Preview Modal */}
      {previewDoc && (
        <div style={styles.modal} onClick={() => setPreviewDoc(null)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>{previewDoc.title[language]}</h2>
              <button 
                onClick={() => setPreviewDoc(null)}
                style={styles.closeBtn}
              >
                <FaTimes />
              </button>
            </div>
            <div style={styles.modalBody}>
              <iframe
                src={`/documents/discipline/${previewDoc.file}`}
                style={styles.pdfViewer}
                title={previewDoc.title[language]}
              />
            </div>
            <div style={styles.modalFooter}>
              <a 
                href={`/documents/discipline/${previewDoc.file}`}
                download
                style={styles.modalDownloadBtn}
              >
                <FaDownload style={styles.btnIcon} />
                {t.download}
              </a>
              <button
                onClick={() => setPreviewDoc(null)}
                style={styles.modalCloseBtn}
              >
                {t.close}
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f5f5f5'
  },
  header: {
    backgroundImage: `linear-gradient(135deg, rgba(26, 54, 93, 0.52) 0%, rgba(44, 82, 130, 0.48) 100%), url(${COVER_BG_IMAGE})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '80px 20px 60px',
    textAlign: 'center',
    color: 'white'
  },
  title: {
    fontSize: '48px',
    fontWeight: 'bold',
    marginBottom: '15px',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
  },
  subtitle: {
    fontSize: '20px',
    marginBottom: '30px',
    opacity: 0.9
  },
  statsBar: {
    display: 'flex',
    justifyContent: 'center',
    gap: '40px',
    marginTop: '30px'
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.2)',
    padding: '20px 40px',
    borderRadius: '15px',
    backdropFilter: 'blur(10px)'
  },
  statNumber: {
    fontSize: '36px',
    fontWeight: 'bold'
  },
  statLabel: {
    fontSize: '16px',
    marginTop: '5px'
  },
  documentsSection: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '60px 20px'
  },
  documentsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
    gap: '30px'
  },
  docCard: {
    background: 'white',
    borderRadius: '15px',
    padding: '30px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    transition: 'all 0.3s',
    cursor: 'pointer',
    animation: 'fadeInUp 0.6s ease forwards',
    opacity: 0,
    display: 'flex',
    gap: '20px',
    alignItems: 'flex-start'
  },
  docIcon: {
    flexShrink: 0
  },
  docContent: {
    flex: 1
  },
  docTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '15px'
  },
  docMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '20px'
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#666'
  },
  metaIcon: {
    color: '#c41e3a',
    fontSize: '14px'
  },
  docActions: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },
  previewBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    background: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  downloadBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 20px',
    background: 'linear-gradient(135deg, #1a365d 0%, #2c5282 100%)',
    color: 'white',
    textDecoration: 'none',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'all 0.3s'
  },
  btnIcon: {
    fontSize: '14px'
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px',
    animation: 'fadeIn 0.3s ease'
  },
  modalContent: {
    background: 'white',
    borderRadius: '15px',
    width: '90%',
    maxWidth: '1200px',
    height: '90vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: '0 10px 50px rgba(0,0,0,0.3)'
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 30px',
    borderBottom: '2px solid #f0f0f0',
    background: '#f8f9fa'
  },
  modalTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    margin: 0
  },
  closeBtn: {
    background: 'transparent',
    border: 'none',
    fontSize: '24px',
    color: '#666',
    cursor: 'pointer',
    padding: '5px 10px',
    transition: 'all 0.3s',
    borderRadius: '50%'
  },
  modalBody: {
    flex: 1,
    padding: '20px',
    overflow: 'hidden',
    background: '#f5f5f5'
  },
  pdfViewer: {
    width: '100%',
    height: '100%',
    border: 'none',
    borderRadius: '10px',
    background: 'white'
  },
  modalFooter: {
    display: 'flex',
    gap: '15px',
    padding: '20px 30px',
    borderTop: '2px solid #f0f0f0',
    background: '#f8f9fa',
    justifyContent: 'flex-end'
  },
  modalDownloadBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 25px',
    background: 'linear-gradient(135deg, #1a365d 0%, #2c5282 100%)',
    color: 'white',
    textDecoration: 'none',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  modalCloseBtn: {
    padding: '12px 25px',
    background: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s'
  }
};

// Ajouter l'animation CSS
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .docCard:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  }

  .previewBtn:hover {
    background: #0056b3;
    transform: scale(1.05);
  }

  .downloadBtn:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(196, 30, 58, 0.3);
  }

  .closeBtn:hover {
    background: #f0f0f0;
    color: #c41e3a;
  }

  .modalDownloadBtn:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 15px rgba(196, 30, 58, 0.3);
  }

  .modalCloseBtn:hover {
    background: #5a6268;
  }

  @media (max-width: 768px) {
    .documentsGrid {
      grid-template-columns: 1fr !important;
    }
  }
`;
document.head.appendChild(styleSheet);

export default DisciplinePage;
